import { BoxItem } from '@/box/interface'
import { TemplateItem } from '@/template/interface'
import { Guid } from '@/utils/guid'
import { Checkbox, Col, Modal, Row, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { appModules, defaultAppModules } from './DefaultValues'

export interface AppModuleCheckListProps {
  visible?: boolean
  template?: TemplateItem
  boxItems?: BoxItem[]
  onOk?: (items: string[]) => void
  onCancel?: () => void
}

export const AppModuleCheckList: React.FC<AppModuleCheckListProps> = (
  props: AppModuleCheckListProps
) => {
  const [checkedModules, setCheckedModules] = useState<string[]>([])
  const [fullMode, setFullMode] = useState<boolean>(false)
  const [differentialBoxes, setDifferentialBoxes] = useState<BoxItem[]>([])

  const resetModules = () => {
    if (props.template) {
      if (props.boxItems) {
        const boxes = props.boxItems.filter((x) => {
          if (!x.template) return false
          return x.template.id !== props.template!.id
        })
        // 存在不同模板的设备，不能选择应用，需要全量覆盖
        if (boxes.length > 0) {
          setCheckedModules(defaultAppModules)
          setDifferentialBoxes(boxes)
          setFullMode(true)
          return
        } else {
          setFullMode(false)
        }
      }

      const items: string[] = []
      defaultAppModules.forEach((x) => {
        const m = props.template![x]
        if (m !== undefined) {
          if (Array.isArray(m)) {
            if (m.length > 0) {
              items.push(x)
            }
          } else if (m > 0) {
            items.push(x)
          }
        }
      })
      if (items.length > 0) {
        setCheckedModules(items)
        return
      }
    }
    setCheckedModules(defaultAppModules)
  }

  const handleCancel = () => {
    resetModules()
    props.onCancel?.()
  }

  useEffect(() => {
    resetModules()
  }, [props.template, props.boxItems])

  return (
    <Modal
      title='选择应用模块'
      visible={props?.visible}
      onOk={() => props.onOk?.(checkedModules)}
      onCancel={handleCancel}
      width={400}
      maskClosable={false}
      destroyOnClose={true}
    >
      <Checkbox.Group
        value={checkedModules}
        onChange={(values) => setCheckedModules(values as string[])}
      >
        {appModules.map((x) => (
          <Row key={Guid.raw()} style={{ marginBottom: 10 }}>
            <Col key={Guid.raw()} span={24}>
              <Checkbox key={Guid.raw()} value={x.value} disabled={fullMode}>
                {x.label}
              </Checkbox>
            </Col>
          </Row>
        ))}
      </Checkbox.Group>
      {fullMode && (
        <Typography.Paragraph type='warning'>
          设备:【{differentialBoxes.map((x) => x.boxNo).join(', ')}
          】与应用的模板不一致，无法选择应用，须全量应用。
        </Typography.Paragraph>
      )}
    </Modal>
  )
}
